import DeletePDFFooterImage from '@/assets/images/organize/organize-delete.png';
import ExtractPDFFooterImage from '@/assets/images/organize/organize-extract.png';
import RotatePDFFooterImage from '@/assets/images/organize/organize-rotate.png';
import SplitPDFFooterImage from '@/assets/images/organize/Split.png';
import OrganizePDFFooterImage from '@/assets/images/conversion/organize-tool.png';
import ExceededConversionError from '@/errors/ExceededConversionError';
import ValidationError from '@/errors/ValidationError';
import { hasFreeOperations } from '@/utils/accessControl';
import { getFileExtension } from '@/utils/files';
import { getI18nInstance } from '@/utils/i18n';
import { formatBytes } from '@/utils/miscellaneous';

/**
 * Maximum file size allowed (in bytes).
 */
export const MAX_FILE_SIZE_BYTES = 15728640; // 15MB

/**
 * Sets maximum free compression number for a user per day.
 * Allowed values:
 *  - null or negative integer number: unlimited conversions
 *  - positive integer number: specific conversions limit
 */
export const MAX_FREE_COMPRESSION_PER_DAY = 1;

const ALLOWED_FILE_EXTENSIONS = ['pdf'];

export function validateInputFile(file: File) {
  const i18n = getI18nInstance();

  if (!hasFreeOperations('organize')) {
    throw new ExceededConversionError(
      i18n.translate('pdfextra_organize_tool.errors.max_free_conversions', {
        MAX_FREE_CONVERSION_PER_DAY: Number(MAX_FREE_COMPRESSION_PER_DAY).toString(),
      })
    );
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new ValidationError(
      i18n.translate('pdfextra_organize_tool.errors.file_too_large', {
        MAX_FILE_SIZE: formatBytes(MAX_FILE_SIZE_BYTES),
      })
    );
  }

  const extension = getFileExtension(file.type);

  if (!ALLOWED_FILE_EXTENSIONS.includes(extension)) {
    throw new ValidationError(
      i18n.translate('pdfextra_organize_tool.errors.not_supported_file_format', {
        allowedExtensions: ALLOWED_FILE_EXTENSIONS.join(', '),
      })
    );
  }
}

export const getOrganizeFooterImage = (): string => {
  const rotateTool = window.location.pathname.includes('/rotate-pdf-pages');
  const deleteTool = window.location.pathname.includes('/delete-pdf-pages');
  const extractTool = window.location.pathname.includes('/extract-pdf');
  const splitTool = window.location.pathname.includes('/split-pdf');

  switch (true) {
    case rotateTool:
      return RotatePDFFooterImage;
    case deleteTool:
      return DeletePDFFooterImage;
    case extractTool:
      return ExtractPDFFooterImage;
    case splitTool:
      return SplitPDFFooterImage;
    default:
      return OrganizePDFFooterImage;
  }
};
